import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc Reports defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ReportsService } from 'services/reports';
 *
 * // create service instance and send/cancel request
 * const reportsService = new ReportsService();
 * const result = await reportsService.fetchData( '<user-id>' ); // fetch data
 * reportsService.cancel(); // cancel an active request
 */
export class ReportsService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: get( CONFIG, 'endpoints.routes.reporting', '' ),
                data,
            } );

            // extract widgets from the response
            const tabs = get( response, 'body.component.structure.tabs', {} );
            const visibility = get( response, 'body.component.visibility', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    tabs: getVisibleItems( tabs, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
